/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const chatbox = $root.chatbox = (() => {

    /**
     * Namespace chatbox.
     * @exports chatbox
     * @namespace
     */
    const chatbox = {};

    chatbox.Message = (function() {

        /**
         * Properties of a Message.
         * @memberof chatbox
         * @interface IMessage
         * @property {string|null} [values] Message values
         */

        /**
         * Constructs a new Message.
         * @memberof chatbox
         * @classdesc Represents a Message.
         * @implements IMessage
         * @constructor
         * @param {chatbox.IMessage=} [properties] Properties to set
         */
        function Message(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Message values.
         * @member {string} values
         * @memberof chatbox.Message
         * @instance
         */
        Message.prototype.values = "";

        /**
         * Creates a new Message instance using the specified properties.
         * @function create
         * @memberof chatbox.Message
         * @static
         * @param {chatbox.IMessage=} [properties] Properties to set
         * @returns {chatbox.Message} Message instance
         */
        Message.create = function create(properties) {
            return new Message(properties);
        };

        /**
         * Encodes the specified Message message. Does not implicitly {@link chatbox.Message.verify|verify} messages.
         * @function encode
         * @memberof chatbox.Message
         * @static
         * @param {chatbox.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.values != null && Object.hasOwnProperty.call(message, "values"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.values);
            return writer;
        };

        /**
         * Encodes the specified Message message, length delimited. Does not implicitly {@link chatbox.Message.verify|verify} messages.
         * @function encodeDelimited
         * @memberof chatbox.Message
         * @static
         * @param {chatbox.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Message message from the specified reader or buffer.
         * @function decode
         * @memberof chatbox.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {chatbox.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.chatbox.Message();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.values = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Message message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof chatbox.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {chatbox.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Message message.
         * @function verify
         * @memberof chatbox.Message
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Message.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.values != null && message.hasOwnProperty("values"))
                if (!$util.isString(message.values))
                    return "values: string expected";
            return null;
        };

        /**
         * Creates a Message message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof chatbox.Message
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {chatbox.Message} Message
         */
        Message.fromObject = function fromObject(object) {
            if (object instanceof $root.chatbox.Message)
                return object;
            let message = new $root.chatbox.Message();
            if (object.values != null)
                message.values = String(object.values);
            return message;
        };

        /**
         * Creates a plain object from a Message message. Also converts values to other types if specified.
         * @function toObject
         * @memberof chatbox.Message
         * @static
         * @param {chatbox.Message} message Message
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Message.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.values = "";
            if (message.values != null && message.hasOwnProperty("values"))
                object.values = message.values;
            return object;
        };

        /**
         * Converts this Message to JSON.
         * @function toJSON
         * @memberof chatbox.Message
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Message.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Message
         * @function getTypeUrl
         * @memberof chatbox.Message
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/chatbox.Message";
        };

        return Message;
    })();

    return chatbox;
})();

export { $root as default };
